import { useLocation, useNavigate } from "react-router-dom";

/** A direct Mini App launch has no in-app history, even after a redirect. */
export function useWheelBackNavigation() {
    const navigate = useNavigate();
    const { search } = useLocation();

    return () => {
        const historyState: unknown = window.history.state;
        const canGoBack =
            typeof historyState === "object" &&
            historyState !== null &&
            "idx" in historyState &&
            typeof historyState.idx === "number" &&
            historyState.idx > 0;

        if (canGoBack) {
            navigate(-1);
        } else {
            navigate({ pathname: "/", search }, { replace: true });
        }
    };
}
